var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemAddSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7.333 5.172v2.161H5.172a.666.666 0 1 0 0 1.334h2.161v2.161a.666.666 0 1 0 1.334 0V8.667h2.161A.665.665 0 0 0 11.495 8a.666.666 0 0 0-.667-.667H8.667V5.172a.666.666 0 1 0-1.334 0",
  clipRule: "evenodd"
})));
export default SvgGemAddSmall;